import React from 'react';
import Accent from '@/components/typography/Accent';
import Paragraph from '@/components/typography/Paragraph';

const Workflow = () => (
  <>
    <Paragraph>
      <Accent>In 10 years</Accent> I went from Windows to <Accent>Mac</Accent>,
      from Notepad++, to Sublime, to <Accent>VSCode</Accent>. From transfering
      pages with FTP, to deploying with <Accent>CircleCI</Accent>. From pushing
      stuff on BitBucket, to Gitlab, and finally <Accent>Github</Accent>.
    </Paragraph>
    <Paragraph>
      <Accent>Vim</Accent> is not a great friend of mine, but I manage the
      basics. Maybe Warp is more my thing.
    </Paragraph>
    <Paragraph>
      <Accent>Chrome DevTools</Accent> is a winner.
    </Paragraph>
    <Paragraph>
      <Accent>
        There’s no such thing as the best Front End Development workflow, but I
        dare to think I am getting there.
      </Accent>
    </Paragraph>
  </>
);

Workflow.propTypes = {};

export default Workflow;
